import React from 'react';
import { Provider } from 'react-redux';
import { MemoryRouter } from 'react-router';

import { SurveyState } from 'store/SurveyState';
import { Store } from 'redux';
import type { StoryContext } from '@storybook/react-webpack5';

type StoreProviderPropsWithStore = React.PropsWithChildren<{}> & {
  store: Store<SurveyState>;
  options?: never;
};

type StoreProviderPropsWithOptions = React.PropsWithChildren<{}> & {
  options: StoryContext;
  store?: never;
};

export type StoreProviderProps = StoreProviderPropsWithStore | StoreProviderPropsWithOptions;

export const StoreProvider: React.FC<StoreProviderProps> = ({ children, options, store }) => {
  return (
    <Provider store={(options?.args?.store ?? store) as Store<SurveyState>}>
      <MemoryRouter
        initialEntries={[
          '/test-distribution/preview',
          '/test-distribution/preview/page/1',
          '/test-distribution/preview/page/2',
          '/test-distribution/preview/submit',
          '/test-distribution/preview/success',
        ]}
        initialIndex={0}
      >
        {children}
      </MemoryRouter>
    </Provider>
  );
};
